<template>
  <section class="cart-drawer-group">
    <slot />
  </section>
</template>

<script>

/**
 * Vue: cart drawer group (cart-drawer-group)
 * -----------------------------------------------------------------------------
 * Cart drawer section group component.
 *
 */

export default {
  name: 'CartGroup',
}
</script>
